import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import apiClient, { formatApiErrorDetail } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { googleRedirectUri } from "@/lib/googleAuth";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const expected = sessionStorage.getItem("g_oauth_state");
    sessionStorage.removeItem("g_oauth_state");

    if (params.get("error") || !code) {
      toast.error("Google sign-in was cancelled.");
      navigate("/login", { replace: true });
      return;
    }
    if (expected && state !== expected) {
      toast.error("Sign-in verification failed. Please try again.");
      navigate("/login", { replace: true });
      return;
    }
    apiClient
      .post("/auth/google/callback", { code, redirect_uri: googleRedirectUri() })
      .then(({ data }) => {
        loginWithToken(data.token, data.user);
        navigate("/dashboard", { replace: true });
      })
      .catch((e) => {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Google sign-in failed.");
        navigate("/login", { replace: true });
      });
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-cream" data-testid="google-callback">
      <Loader2 className="h-8 w-8 animate-spin text-orange" />
      <p className="font-700 text-ink/70">Signing you in…</p>
    </div>
  );
}
